import { render, staticRenderFns } from "./CreateCoffeeTree.vue?vue&type=template&id=535747a6"
import script from "./CreateCoffeeTree.vue?vue&type=script&lang=js"
export * from "./CreateCoffeeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports